module.exports = __webpack_public_path__ + "img/ifmPa.7c5d0ebf.svg";